import footer from "assets/graphics/footer.png";
import { Link } from "react-router-dom";

const Header = () => {
  return (
    <footer className="text-center mt-4">
      <Link to="/">
        <img
          src={footer}
          className="img-fluid"
          style={{
            height: "100px",
          }}
          alt="Agnieszka i Bartosz"
        />
      </Link>
    </footer>
  );
};

export default Header;
